<div class="d-flex align-items-center position-relative">
  <input
      [id]="name"
      type="text"
      class="form-control"
      [(ngModel)]="currentValue"
      (keydown.enter)="onEnterPress($event)"
      [autocomplete]="autocomplete"
      [placeholder]="'Start typing and press \'Enter\' or the plus button to add new value'"
      [ngClass]="{ 'input-btn-present': currentValue }">
  <a *ngIf="currentValue" class="add-value-btn" [ngbTooltip]="'Add value'" (click)="addValue()">
    <fa-icon [icon]="addValueIcon" [size]="'lg'"></fa-icon>
  </a>
</div>
<div class="d-flex flex-wrap">
  <div *ngFor="let item of control.value; let i = index" class="value-badge">
    {{ item }}
    <a (click)="removeValue(i)">
      <fa-icon [icon]="removeValueIcon" [size]="'sm'"></fa-icon>
    </a>
  </div>
</div>
<app-input-errors class="input-error" [control]="control"></app-input-errors>
